import React, { useState } from 'react';

const CONTACT_LINKS = [
  {
    title: 'Telegram',
    value: '@Akylich_Ilya',
    link: 'https://t.me/Akylich_Ilya',
    icon: '📱',
    color: 'from-blue-400 to-blue-600',
    description: 'Быстрая поддержка в мессенджере'
  },
  {
    title: 'Discord',
    value: 'discord.gg/sharkly',
    link: 'https://discord.gg/sharkly',
    icon: '',
    color: 'from-indigo-500 to-purple-600',
    description: 'Присоединяйся к нашему сообществу'
  },
  {
    title: 'Steam',
    value: 'steamcommunity.com/id/Akylich_ilya',
    link: 'https://steamcommunity.com/id/Akylich_ilya/',
    icon: '',
    color: 'from-[#1b2838] to-[#2a475e]',
    description: 'Наш профиль в Steam'
  },
  {
    title: 'Email',
    value: 'support@sharkly.ru',
    link: 'mailto:support@sharkly.ru',
    icon: '',
    color: 'from-gray-500 to-gray-700',
    description: 'Ответим в течение 24 часов'
  },
];

const ContactPage: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="max-w-6xl mx-auto p-6 pb-24 md:pb-6">
      {/* Заголовок */}
      <div className="text-center mb-16 relative">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-blue-500/20 rounded-full blur-[100px] -z-10"></div>
        <h1 className="text-4xl md:text-6xl font-black text-white mb-4 flex items-center justify-center gap-3 tracking-tight">
          📞 Связь с нами
        </h1>
        <p className="text-gray-400 text-lg max-w-2xl mx-auto leading-relaxed">
          Есть вопросы, предложения или хочешь стать частью команды?
          Напиши нам — мы всегда на связи!
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
        {/* Контактная информация - КЛИКАБЕЛЬНЫЕ КАРТОЧКИ ОДИНАКОВОЙ ВЫСОТЫ */}
        <div className="flex flex-col gap-4">
          <h2 className="text-xl font-bold text-white mb-2 flex items-center gap-2">
             Наши контакты
          </h2>

          <div className="grid grid-cols-1 gap-4 flex-1">
            {CONTACT_LINKS.map((contact, i) => (
              <a
                key={i}
                href={contact.link}
                target="_blank"
                rel="noopener noreferrer"
                className="group block bg-[#1a1d24] rounded-2xl border border-gray-800 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-gray-600 hover:shadow-lg h-full"
              >
                <div className="flex items-center gap-4 h-full">
                  {/* Иконка с градиентом */}
                  <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${contact.color} flex items-center justify-center text-2xl shrink-0 shadow-lg group-hover:scale-110 transition-transform`}>
                    {contact.icon}
                  </div>

                  {/* Текст */}
                  <div className="flex-1 min-w-0 flex flex-col justify-center">
                    <h3 className="text-lg font-bold text-white group-hover:text-blue-400 transition-colors leading-tight">
                      {contact.title}
                    </h3>
                    <p className="text-sm text-blue-400 truncate font-medium">
                      {contact.value}
                    </p>
                    <p className="text-xs text-gray-500 mt-1 leading-tight">
                      {contact.description}
                    </p>
                  </div>

                  {/* Стрелка */}
                  <div className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center text-gray-400 group-hover:bg-blue-600 group-hover:text-white transition-all shrink-0">
                    ↗
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Форма обратной связи */}
        <div className="bg-[#1a1d24] rounded-3xl border border-gray-800 p-8">
          <h2 className="text-xl font-bold text-white mb-6 flex items-center gap-2">
            ✉️ Написать сообщение
          </h2>

          {submitted ? (
            <div className="text-center py-12">
              <div className="text-6xl mb-4 animate-bounce">✅</div>
              <h3 className="text-2xl font-bold text-green-400 mb-2">Сообщение отправлено!</h3>
              <p className="text-gray-400">Мы свяжемся с вами в ближайшее время</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-sm font-bold text-gray-300 mb-2">Имя</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Как к вам обращаться?"
                  className="w-full bg-[#0f1115] border border-gray-700 rounded-xl px-4 py-3 text-white focus:border-blue-500 outline-none transition focus:ring-2 focus:ring-blue-500/20"
                />
              </div>

              <div>
                <label className="block text-sm font-bold text-gray-300 mb-2">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="your@email.com"
                  className="w-full bg-[#0f1115] border border-gray-700 rounded-xl px-4 py-3 text-white focus:border-blue-500 outline-none transition focus:ring-2 focus:ring-blue-500/20"
                />
              </div>

              <div>
                <label className="block text-sm font-bold text-gray-300 mb-2">Тема</label>
                <select
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="w-full bg-[#0f1115] border border-gray-700 rounded-xl px-4 py-3 text-white focus:border-blue-500 outline-none transition focus:ring-2 focus:ring-blue-500/20 appearance-none cursor-pointer"
                  style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%239ca3af' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 1rem center' }}
                >
                  <option value="">Выберите тему</option>
                  <option value="general">Общий вопрос</option>
                  <option value="bug">Сообщить об ошибке</option>
                  <option value="feature">Предложение функции</option>
                  <option value="sponsorship">Вопрос о спонсорстве</option>
                  <option value="partnership">Сотрудничество</option>
                  <option value="other">Другое</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-bold text-gray-300 mb-2">Сообщение</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={5}
                  placeholder="Опишите ваш вопрос подробно..."
                  className="w-full bg-[#0f1115] border border-gray-700 rounded-xl px-4 py-3 text-white focus:border-blue-500 outline-none resize-none transition focus:ring-2 focus:ring-blue-500/20"
                />
              </div>

              <button
                type="submit"
                className="w-full py-3.5 rounded-xl font-bold bg-gradient-to-r from-blue-600 to-emerald-600 hover:from-blue-500 hover:to-emerald-500 text-white transition shadow-[0_0_20px_rgba(37,99,235,0.4)] hover:shadow-[0_0_30px_rgba(37,99,235,0.6)] active:scale-[0.98]"
              >
                Отправить сообщение
              </button>
            </form>
          )}
        </div>
      </div>

      {/* Время работы */}
      <div className="bg-[#1a1d24]/50 backdrop-blur-sm rounded-3xl border border-gray-800/50 p-8 text-center">
        <h3 className="text-lg font-bold text-white mb-2">🕐 Время работы поддержки</h3>
        <p className="text-gray-400">Пн-Пт: 10:00 - 20:00 (МСК) • Сб-Вс: 12:00 - 18:00 (МСК)</p>
      </div>
    </div>
  );
};

export default ContactPage;